module.exports = __webpack_public_path__ + "img/check.a51363e9.svg";